import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PlanCard from 'components/PlanSelector/components/PlanCard';
import styles from './index.module.scss';

const GeneratedPaymentPlansScreen: React.FC = () => {
  const location = useLocation<{
    paymentToken?: string;
    fromPayment?: boolean;
    paymentPlanData?: {
      plan: any;
      price: any;
    };
  }>();

  const fromPayment = location.state?.fromPayment ?? false;
  const paymentPlanData = location.state?.paymentPlanData;
  const { paymentToken } = useParams<{ paymentToken?: string }>();

  const planWithPrice = React.useMemo(() => {
    if (!paymentPlanData) return null;
    return { ...paymentPlanData.plan, price: paymentPlanData.price };
  }, [paymentPlanData]);

  if (!planWithPrice) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>Plan Details</h1>
        </div>
        <p>Loading plan information...</p>
      </div>
    );
  }
  const MemoizedPlanCard = React.memo(() => (
    <div className={styles.centerStyle}>
      <PlanCard
        plan={planWithPrice}
        fromPayment={fromPayment}
        paymentToken={paymentToken}
      />
    </div>
  ));

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Plan Details</h1>
      </div>

      <MemoizedPlanCard />
      <p className={styles.description}>
        Plan and content will be available only in the countries listed in the
        chosen plan. HD (720p), Full HD (1080p), Ultra HD (4K) and HDR
        availability subject to your internet service and device capabilities.
        Not all content available in HD, Full HD, Ultra HD, or HDR. See Terms of
        Use for more details.
      </p>
    </div>
  );
};

export default React.memo(GeneratedPaymentPlansScreen);
